import { render, staticRenderFns } from "./AppointmentStatusBadge.vue?vue&type=template&id=27fa8aa4&scoped=true&"
import script from "./AppointmentStatusBadge.vue?vue&type=script&lang=js&"
export * from "./AppointmentStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fa8aa4",
  null
  
)

export default component.exports